import React, { useEffect, useState } from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { StyledKeyboardDatePicker, StyledKeyboardDatePickerProps } from './style';

interface InlineKeyboardDatePickerProps extends Omit<StyledKeyboardDatePickerProps, 'onChange'> {
    onChange(date: Date | null): void;
}

const InlineKeyboardDatePicker = ({ value, onChange, ...props }: InlineKeyboardDatePickerProps) => {
    const [pickedDate, setPickedDate] = useState<Date | null>(value ? new Date(value as string) : null);

    useEffect(() => {
        const parsedValue = value ? new Date(value as string) : null;

        if (parsedValue !== pickedDate) {
            setPickedDate(parsedValue);
        }
    // eslint-disable-next-line
    }, [value]);

    const handleChange = (date: MaterialUiPickersDate) => {
        setPickedDate(date ? date.toJSDate() : null);
        if (!date) {
            onChange(date);
        } else {
            const { isValid } = date;
            if (isValid) {
                onChange(date.toJSDate());
            }
        }
    };

    return (
        <StyledKeyboardDatePicker
            {...props}
            value={pickedDate}
            onChange={handleChange}
        />
    );
};

export default InlineKeyboardDatePicker;
